import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "patra-install-dismissed";
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(KEY)) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setVisible(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS()) setVisible(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { localStorage.setItem(KEY, "1"); setVisible(false); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div data-testid="install-prompt" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:w-96 z-50 rounded-xl border border-slate-200 bg-white shadow-lg p-4 flex gap-3 items-start">
      <img src="/icon-192.png" alt="PATRA" className="h-10 w-10 rounded-lg border border-slate-100" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-slate-800">Pasang PATRA FMS di HP</p>
        {deferred ? (
          <p className="text-xs text-slate-500 mt-0.5">Buka lebih cepat, layar penuh seperti aplikasi.</p>
        ) : (
          <p className="text-xs text-slate-500 mt-0.5 flex items-center gap-1 flex-wrap">Ketuk <Share className="h-3 w-3 inline" /> <span className="font-medium">Share</span> lalu pilih <span className="font-medium">Add to Home Screen</span>.</p>
        )}
        {deferred && (
          <Button size="sm" className="mt-2 h-8" onClick={install} data-testid="install-app-btn"><Download className="h-3.5 w-3.5 mr-1" />Pasang Aplikasi</Button>
        )}
      </div>
      <button onClick={dismiss} className="text-slate-400 hover:text-slate-600" aria-label="Tutup" data-testid="install-prompt-close"><X className="h-4 w-4" /></button>
    </div>
  );
}
